<template>
  <div class="user-comments">
    <h1 class="heading">
      {{ allCommentsUserHeading }}
    </h1>
    <list
      :items="myComments"
      :placeholders="placeholders"
      :grid="true"
      :empty="'placeholders.NO_COMMENTS'"
    >
      <template v-slot:action>
        <pagination-controls
          :page="page"
          :page-count="pageCount"
          :page-size="pageSize"
          :minified="true"
          @changePage="setPage"
        />
      </template>
      <template v-slot:sort>
        <section class="list__controls">
          <div class="input">
            <input
              type="radio"
              id="sort__all"
              name="sort__all"
              value="all"
              v-model="sorting"
            >
            <label
              class="label__options"
              for="sort__all"
            >{{
              $t("labels.SORT_ALL")
            }}</label>
          </div>
          <div class="input">
            <input
              type="radio"
              id="sort__published"
              name="sort__published"
              value="published"
              v-model="sorting"
            >
            <label
              class="label__options"
              for="sort__published"
            >{{
              $t("labels.SORT_VISIBLE")
            }}</label>
          </div>
          <div class="input">
            <input
              type="radio"
              id="sort__removed"
              name="sort__removed"
              value="removed"
              v-model="sorting"
            >
            <label
              class="label__options"
              for="sort__removed"
            >{{
              $t("labels.SORT_HIDDEN")
            }}</label>
          </div>
        </section>
      </template>
      <template v-slot:item="{ item }">
        <comment
          :key="item.id"
          :comment="item"
        />
      </template>
    </list>
    <div class="pagination-controls-container-bottom">
      <pagination-controls
        :page="page"
        :page-count="pageCount"
        :page-size="pageSize"
        :minified="false"
        @changePage="setPage"
        @changePageSize="onChangePageSize"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import List from "../components/global/List";
import Comment from "../components/global/Comment";
import PaginationControls from "../components/global/PaginationControls";
import SkeletonPost from "../components/global/SkeletonPost";

export default {
  name: "UserComments",
  components: {
    Comment,
    List,
    PaginationControls,
  },
  data() {
    return {
      page: 0,
      sorting: "all",
    };
  },
  created() {
    this.getMyComments({
      size: this.pageSize,
      offset: this.offset,
      sorting: "",
    });
    this.goToTop();
  },
  computed: {
    ...mapGetters(["myComments", "myCommentCount", "myProfile"]),
    allCommentsUserHeading() {
      return this.$t("headings.COMMENTS_ALL_USER", {
        num: this.myCommentCount,
      });
    },
    offset() {
      return parseInt(this.$route.query.offset, 10);
    },
    pageSize() {
      return parseInt(this.$route.query.pageSize, 10);
    },
    pageCount() {
      return Math.ceil(this.myCommentCount / this.pageSize);
    },
    placeholders() {
      return {
        count: this.pageSize,
        component: SkeletonPost,
      };
    },
  },
  methods: {
    ...mapActions(["getMyComments"]),
    goToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    },
    onChangePageSize(ev) {
      this.$router.push({
        name: "comments",
        query: {
          pageSize: ev.target.value,
          offset: this.offset,
          sorting: this.sorting,
        },
      });
      this.goToTop();
    },
    setPage(val) {
      this.$router.push({
        name: "comments",
        query: {
          pageSize: this.pageSize,
          offset: this.pageSize * val,
          sorting: this.sorting,
        },
      });
      this.page = val;
      this.goToTop();
    },
  },
  watch: {
    sorting() {
      this.$router.push({
        name: "comments",
        query: {
          pageSize: this.pageSize,
          offset: 0,
          sorting: this.sorting,
        },
      });
      this.page = 0;
      this.goToTop();
    },
    $route(to) {
      this.getMyComments({
        size: to.query.pageSize,
        offset: to.query.offset,
        sorting: this.sorting,
      });
    },
  },
};
</script>
